import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { TemplatesCreateFlexpayControllerModule } from './controllers/TemplatesCreateFlexpayController';
import { TemplatesCreateFlexpayCreateView } from './create/create';

export const TemplatesCreateFlexpayView = angular
  .module('acme.view.application.templates.create.flexpay', [
    uiRouter,
    'ui.bootstrap',
    TemplatesCreateFlexpayControllerModule,
    TemplatesCreateFlexpayCreateView,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.templates.create.flexpay',
      url: '/flexpay',
      views: {
        'subview-main': {
          controller: 'TemplatesCreateFlexpayController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/flexpay/flexpay.tpl.html',
        },
      },
      data: {
        pageTitle: 'Create Event Template Flex Pay',
      },
    });

    $stateProvider.state({
      name: 'application.templates.edit.flexpay',
      url: '/flexpay',
      views: {
        'subview-main': {
          controller: 'TemplatesCreateFlexpayController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/templates/create/flexpay/flexpay.tpl.html',
        },
      },
      data: {
        pageTitle: 'Edit Event Template Pricing',
      },
    });
  }).name;
